<template>
  <div @click="clickShare">
    <slot />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setShare, openShareBoard } from '@/plugins/share'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { isMmz } from '@/utils'
import { queryShareKey } from '@/service/product'
export default {
  props: {
    promotionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    spuId: String
  },
  computed: {
    ...mapState(['isMinProgram', 'product'])
  },
  data() {
    return {
      originUrl: '',
      shareImg: '',
      shareData: null,
      miniProgramShareKey: '',
      price: 0,
      tag: '',
      shareRemark: {}
    }
  },
  watch: {
    promotionInfo() {
      this.init()
    }
  },
  async mounted() {
    this.init()
    //取链接上的分享key赋值到miniProgramShareKey
    const params = location.search.replace(/^\?/, '').split('&')
    params.forEach(p => {
      const res = p.split('=')
      if (res[0] === 'hserecomkey') {
        this.miniProgramShareKey = res[1]
      }
    })
    if (this.isMinProgram) {
      const uid = this.$$cookie.get('uid')
      const skey = this.$$cookie.get('skey')
      //在小程序中重新获取sharekey做二次分享用
      if (uid && skey) {
        const shareKey = await queryShareKey(this.shareRemark)
        this.miniProgramShareKey = shareKey
      }
    }
  },
  methods: {
    async init() {
      this.price = this.promotionInfo.price ?? this.product.minPrice
      this.tag = this.promotionInfo.tag || ''
      this.originUrl = this.product.shareImage
      if (
        !this.originUrl &&
        this.product.cmmdtyImages &&
        this.product.cmmdtyImages.length > 0
      ) {
        this.originUrl =
          this.product.cmmdtyImages && this.product.cmmdtyImages[0]
      }
      this.shareImg = `https:${utils.imagePreview(
        this.originUrl,
        500,
        400,
        'jpg',
        1
      )}`
      this.shareData = await this.$store.dispatch('getShareImage', {
        imageUrl: this.shareImg,
        price: this.price,
        product_name: this.product.spuName
      })
      this.shareRemark = {
        url: encodeURIComponent(location.href),
        contentType: this.promotionInfo.contentType
          ? this.promotionInfo.contentType
          : 201,
        contentId: this.product.spuId || ''
      }
    },
    removeUrlKey(url, keys) {
      const params = url.split('?')
      let formattedParams =
        params.length > 1 ? queryString.parse(params[1]) : {}
      keys.forEach(str => {
        if (Object.keys(formattedParams).includes(str)) {
          delete formattedParams[str]
        }
      })
      return params[0] + '?' + queryString.stringify(formattedParams)
    },
    //文档地址https://p6fpo8391v.feishu.cn/wiki/wikcnzr4vGfXx6kipG7u5JLFh0A
    clickShare() {
      if (isMmz()) {
        const uid = this.$$cookie('uid')
        const skey = this.$$cookie('skey')
        if (!uid || !skey) {
          location.href = `https://passport.cekid.com/passport/login?cmd=login`
          return
        }
        const link = encodeURIComponent(
          location.href +
            (location.href.indexOf('?') === -1 ? '?' : '&') +
            'mmz=1'
        )
        location.href = `https://w.cekid.com?cmd=kwmothersharepage&goodstype=1&spuid=${this.product.spuId}&linktype=126&tooltype=702&link=${link}`
        return
      }
      //分享的时候删除module fromDailySale 等订单转化字段
      const __link = this.removeUrlKey(location.href, [
        'module',
        'fromDailySale'
      ])
      const title = this.promotionInfo.title || this.product.spuName
      const desc = this.product.spuDesc
        ? this.product.spuDesc.replace(/<[^>]+>/g, '')
        : '孩子王为您提供专业服务，品质生活认准孩子王育儿服务平台'
      let miniData = {}
      if (this.isMinProgram) {
        //替换新的分享key
        const params = __link.split('?')
        let formattedParams =
          params.length > 1 ? queryString.parse(params[1]) : {}
        formattedParams.hserecomkey = this.miniProgramShareKey
        const realLink =
          params[0] + '?' + queryString.stringify(formattedParams)
        miniData = {
          title,
          link: realLink, // 分享链接
          imageList: [
            `https:${utils.imagePreview(this.originUrl, 400, 400, 'jpg', 1)}`
          ], // 海报里的主图，多规格商品可以传多个图片
          price: this.price, // 价格，单位分，非必传
          tags: this.tag ? [this.tag] : [],
          //   priceName: '秒杀价', // 价格名称，非必传
          // hserecomkey: this.miniProgramShareKey, // 分享key
          pageTitle: '分享', // 分享页标题
          backgroundImage: this.originUrl
        }
      }
      const link = miniData.link || __link

      setShare(
        {
          link,
          channel: '2,5,6,7,3,8', //  2-图文
          userName: 'gh_362b01c44275', // 孩子王小程序
          remark: JSON.stringify(this.shareRemark),
          title,
          desc: desc,
          imgUrl: (this.shareData && this.shareData.image_url) || this.shareImg,
          path: `/pages/mall-index/index?refererH5=${encodeURIComponent(link)}`,
          dpH5: 1,
          dpinfoH5: JSON.stringify({
            scene_id: 'czj',
            //   productType: '1',
            imageurl: this.product.shareImage || this.originUrl, // 海报里的主图，1:1，多规格商品图用逗号分割
            product_name: title,
            price: this.price, // 价格，单位分，非必传
            tags: this.tag ? [this.tag] : [],
            // price_name: '秒杀价', // 价格名称，非必传
            link: link,
            path: link
          }),
          page: '/pages/mall-index/index',
          scene: `$$ENCODE(${encodeURIComponent(link)})`
        },
        miniData
      )
      openShareBoard()
    }
  }
}
</script>
